import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { getPageLink } from "utils";
import { Icon, InPlaceEditingPlaceholder } from "components";

import {
  useGetWidgetTitleByType,
  useGetWidgetDescriptionsByType,
} from "hooks/useRecentProjectsLinkWidgetHelper";
import styles from "./RecentProjectsLinkWidget.module.scss";

Scrivito.provideComponent("RecentProjectsLinkWidget", ({ widget, getData }) => {
  const link = widget.get("link");
  const widgetType = widget.get("widgetType");
  const title = useGetWidgetTitleByType(widgetType);
  const descriptions = widget.get("withProjectCountDescription")
    ? [getData()]
    : useGetWidgetDescriptionsByType(widgetType);
  const iconName = widget.get("withIcon") && widget.get("iconName");
  const iconPrefix = widget.get("withIcon") && widget.get("iconPrefix");

  if (!link) {
    return (
      <InPlaceEditingPlaceholder>
        Link should be provided
      </InPlaceEditingPlaceholder>
    );
  }

  return (
    <Scrivito.LinkTag
      data-testid={`RecentProjectLinkWidgetComponent_all-projects-link--${iconName}`}
      to={getPageLink(link)}
      className={cx(
        "d-flex cursor-pointer ps-6 pe-5 align-items-center justify-content-between text-decoration-none position-relative w-100",
        styles.wrapper,
      )}
    >
      <div className="d-flex flex-nowrap align-items-center">
        {iconName && (
          <Icon
            iconName={iconName}
            prefix={iconPrefix}
            className="icon-64 me-4"
            data-testid="icon"
          />
        )}
        <div className="d-flex flex-column">
          <h3 className="text-uppercase mb-1">{title}</h3>
          <div className="d-flex flex-wrap">
            {descriptions.map((label, key) => (
              <h4 key={key} className="d-flex flex-nowrap mb-0">
                <div className="text-nowrap">{label}</div>
                <div className="mx-1">
                  {descriptions.length !== 1 &&
                    descriptions.length !== key + 1 &&
                    "|"}
                </div>
              </h4>
            ))}
          </div>
        </div>
      </div>
      <Icon
        prefix="trox"
        iconName="chevron-right-regular"
        className="icon-40"
      />
    </Scrivito.LinkTag>
  );
});
